import {
    iconRequest,
    iconClient,
    iconCalculator,
    iconSearch,
    iconPays,
    iconDocs,
    DocsDesembolsados,
    iconParameters,
    iconAffiliate,
    iconPolizas,
    iconAseguradoras,
    iconReports,
    iconReportsDefault,
    iconWarranty,
    iconAddDocs,
} from '../defaultValues';

const data = {
    role_a7a630b87d484d97812246633c927dbe: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'neww',
            icon: iconWarranty,
            label: 'Garantía Vehicular',
            subs: [
                {
                    id: 'gestiona-garantias',
                    icon: iconReportsDefault,
                    label: 'Gestionar',
                    to: '/app/warranty',
                },
                {
                    id: 'consulta-garantias',
                    icon: iconReportsDefault,
                    label: 'Consultar',
                    to: '/app/radicationWarranty',
                },
            ],
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    id: 'aliados',
                    icon: iconAffiliate,
                    label: 'Aliados',
                    to: '/app/aliados',
                },
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Calculadora',
                    to: '/app/reports/calculatorParams',
                },
            ],
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
            ],
        },
        {
            id: 'newoptions',
            icon: iconPolizas,
            label: 'Operaciones',
            to: '/app/calculator',
            subs: [
                {
                    id: 'polizas',
                    icon: iconAseguradoras,
                    label: 'Seguros endosados',
                    to: '/app/Polizas',
                },
                {
                    id: 'runtPreRegistration',
                    icon: iconAddDocs,
                    label: 'Pre registro RUNT',
                    to: '/app/calculator',
                    subs: [
                        {
                            id: 'runtPreRegistration',
                            icon: iconAddDocs,
                            label: 'Gestión',
                            to: '/app/credits/RuntPreRegistration',
                        },
                        {
                            id: 'massiveRadicationRunt',
                            icon: iconAddDocs,
                            label: 'Masivo',
                            to: '/app/massiveRadicationRunt',
                        },
                    ],
                },
            ],
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconCalculator,
                    label: 'Simulador de Créditos',
                    to: '/app/calculator',
                },
            ],
        },
        {
            id: 'documentos',
            icon: iconDocs,
            label: 'Documentos',
            to: '/app/calculator',
            subs: [
                {
                    id: 'documents',
                    icon: DocsDesembolsados,
                    label: 'Desembolsados',
                    to: '/app/credits/DisbursementDocuments',
                },
                {
                    id: 'pagare',
                    icon: iconPays,
                    label: 'Pagarés',
                    to: '/app/pagare/list',
                },
            ],
        },
    ],
};
export default data;
